import './Solutions.css'
import solutionImg1 from '../../assets/images/solution1.png'
import solutionImg2 from '../../assets/images/solution2.png'
import solutionImg3 from '../../assets/images/solution3.png'
function Solutions() {
    let data = [
        {
            img: solutionImg1,
            title: "Small to Medium-Sized Enterprises (SMEs)",
            description: "Enhance operational efficiency and reduce administrative overhead."
        },
        {
            img: solutionImg2,
            title: "Freelancers and Independent Contractors",
            description: "Simplify billing with precise time tracking for multiple clients."
        },
        {
            img: solutionImg3,
            title: "Remote and Distributed Teams",
            description: "Maintain accountability and coordination across locations."
        }
    ]
    return (
        <div className='Solutions'>
            <div className='theme-heading-text'>Solutions for Every Industry</div>
            <div className='content'>
                {
                    data?.map((card, index) => {
                        return <div key={index} className={`content-card ${(index % 2 != 0) ? "flex-column-reverse" : "" }`}>
                            <img src={card.img} alt="solutionImg1" />
                            <div className='text-content'>
                                <div className='theme-heading-text-24'>{card.title}</div>
                                <div className='theme-text-small-16'>{card.description}</div>
                            </div>
                        </div>
                    })
                }

            </div>
        </div>
    )
}

export default Solutions
